<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">THE HISTORY OF JERUSALEM</h1>
<p class="titlea">ITS ORIGINS TO THE EARLY MIDDLE AGES</p>
<p class="author">ALAN J. POTTER</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?d7b91720